import { env } from '@/common/config/env';

function photoBase() {
  return (env.photoBaseUrl || '').replace(/\/$/, '');
}

/**
 * Media files live on VITE_PHOTO_BASE_URL, not under the API `/api` prefix.
 * Relative paths and absolute `…/api/media/…` URLs are rewritten onto that host.
 * blob/data URLs and other absolute hosts (S3, CDN) stay unchanged.
 */
export function resolveWhatsAppMediaUrl(file) {
  if (!file || typeof file !== 'string') return '';
  const trimmed = file.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('blob:') || trimmed.startsWith('data:'))
    return trimmed;

  const base = photoBase();

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      const parsed = new URL(trimmed);
      if (parsed.pathname.startsWith('/api/media/')) {
        const path = parsed.pathname.replace(/^\/api/, '') + parsed.search;
        return base ? `${base}${path}` : path;
      }
    } catch {
      return trimmed;
    }
    return trimmed;
  }

  let path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  if (path.startsWith('/api/media/')) path = path.replace(/^\/api/, '');
  if (!base) return path;
  return `${base}${path}`;
}
